import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { TextInputFieldWUT } from '../../../ui/text-input-field';
export const ContactsEmailWUT = props => {
  const fieldType = FIELD_TYPES.CONTACTS_EMAIL;
  return /*#__PURE__*/React.createElement(TextInputFieldWUT, _extends({}, props, {
    type: "email",
    fieldType: fieldType
  }));
};
//# sourceMappingURL=contacts-email-wut.js.map